<template>
  <div class="address_wrap">
    <div v-if="!info" class="c9 center">
      <span>您还未添加收票地址，</span>
      <a v-if="powerReg('2f3319d5edfb8425a7d552178e9d50a3')" class="active_color" @click="add">点击添加</a>
    </div>
    <div v-if="info">
      <el-form ref="ruleForm" :model="info" :rules="rules" label-width="120px" class="mb35">
        <el-form-item label="收件人:" prop="receive_person">
          <el-input v-model="info.receive_person" type="text" placeholder="请输入收件人姓名" class="w100" clearable :disabled="mode == 2" />
        </el-form-item>
        <el-form-item label="手机号:" prop="receive_phone">
          <el-input v-model="info.receive_phone" type="text" placeholder="请输入收件人手机号" class="w100" maxlength="11" clearable :disabled="mode == 2" @keyup.native="info.receive_phone = info.receive_phone.replace(/[^\d]/g, '')" />
        </el-form-item>
        <!-- <el-form-item label="收件地址：" prop="region">
          <el-cascader v-model="info.region" class="w100" :options="cityData" :props="cityProp" placeholder="请选择收件地址" clearable show-all-levels filterable :disabled="mode == 2" />
        </el-form-item> -->
        <el-form-item label="详细地址:" prop="detail">
          <el-input v-model="info.detail" type="text" placeholder="请输入收件详细地址" class="w100" clearable :disabled="mode == 2" />
        </el-form-item>
        <!-- <el-form-item label="邮编：" prop="zip_code">
          <el-input v-model="info.zip_code" type="text" placeholder="请输入邮编" class="w100" clearable maxlength="6" :disabled="mode == 2" @keyup.native="info.zip_code = info.zip_code.replace(/[^\d]/g, '')" />
        </el-form-item> -->
      </el-form>
      <div v-if="info" class="center">
        <el-button v-if="mode == 1" type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button v-if="mode == 1" @click="cancel">取消</el-button>
        <el-button v-if="mode == 2 && powerReg('2ab74e7a23ecad411ee8342a6d763bf4')" type="primary" @click="mode = 1">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getInvoiceAddress, addOrUpdateInvoiceAddress } from '@/api/invoice'

export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (value !== '' && value !== undefined) {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入收件人手机号'))
      }
    }
    return {
      info: null,
      rules: {
        receive_person: [{ required: true, message: '请输入收件人姓名', trigger: 'change' }],
        receive_phone: [{ required: true, validator: validateMobile, trigger: 'change' }],
        // region: [{ required: true, message: '请选择收件地址', trigger: 'change' }],
        detail: [{ required: true, message: '请输入收件详细地址', trigger: 'change' }]
        // zip_code: [{ required: true, message: '请输入邮编', trigger: 'change' }]
      },
      cityData: [],
      cityProp: {
        label: 'name',
        value: 'id'
      },
      mode: 1
    }
  },
  methods: {
    query() {
      // regionList().then(res => {
      //   if (res.code === 200) {
      //     this.cityData = res.data
      //   }
      // })
      getInvoiceAddress().then(res => {
        if (res.code === 200) {
          this.info = res.data.length === 0 ? null : res.data
          if (this.info) {
            // this.info.region = [Number(this.info.province), Number(this.info.city), Number(this.info.country)]
            this.mode = 2
          }
        }
      })
    },
    add() {
      this.mode = 1
      this.info = {
        receive_person: '',
        receive_phone: '',
        // region: '',
        address: '',
        zip_code: ''
      }
    },
    cancel() {
      this.query()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdateInvoiceAddress({
            receive_person: this.info.receive_person,
            receive_phone: this.info.receive_phone,
            // province: this.info.region[0],
            // city: this.info.region[1],
            // country: this.info.region[2],
            address: this.info.detail
            // zip_code: this.info.zip_code
          }).then(res => {
            if (res.code === 200) {
              this.$message({ type: 'success', message: '保存成功' })
              this.query()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address_wrap{
  width: 600px;
  margin: 0 auto;
}
</style>
